export const msConfig = {
    serviceInstance: new Object()
}


// WEBPACK FOOTER //
// ./~/angular-bootstrap-md/modals/modalService.config.ts